import { Box, Flex } from '@chakra-ui/react';

import SkeletonComponent from 'UiKit/skeleton';

import styles from './styles.module.css';

const OverviewContentSkeleton = () => {
  return (
    <Box className={styles['overview-content-skeleton__container']}>
      <Flex flex={1} gap={1} flexDir="column">
        <SkeletonComponent height="13px" width="40%" />
        <SkeletonComponent height="15px" width="50%" />
      </Flex>
      <Flex flex={1} gap={1} flexDir="column">
        <SkeletonComponent height="13px" width="50%" />
        <SkeletonComponent height="15px" width="40%" />
      </Flex>
      <SkeletonComponent height="24px" width="24px" />
    </Box>
  );
};

export default OverviewContentSkeleton;
